function isVisible(obj) {
    if (obj == document) return true

    if (!obj) return false
    if (!obj.parentNode) return false
    if (obj.style) {
        if (obj.style.display == 'none') return false
        if (obj.style.visibility == 'hidden') return false
    }

    //Try the computed style in a standard way
    if (window.getComputedStyle) {
        var style = window.getComputedStyle(obj, "")
        if (style.display == 'none') return false
        if (style.visibility == 'hidden') return false
    }

    //Or get the computed style using IE's silly proprietary way
    var style = obj.currentStyle
    if (style) {
        if (style['display'] == 'none') return false
        if (style['visibility'] == 'hidden') return false
    }

    return isVisible(obj.parentNode)
}
window.isVisible = isVisible;
(function($){
  function trim(el) {
    return (''.trim) ? el.val().trim() : $.trim(el.val());
    }

    $.fn.isFormHappy = function() {
        var happy = true;
        var funcs = this.data("happyValidFunc");
        for (var i = 0; i < funcs.length; i++) {
            if (funcs[i]() && happy)
                happy = false;
        }
        return happy;
    };
    function validateFields(fields) {
        var errors = false, i, l;
        for (i = 0, l = fields.length; i < l; i += 1) {
            if (!fields[i].testValid(true)) {
                errors = true;
            }
        }
        return errors;
    }
  $.fn.isHappy = function (config) {
    var fields = [], item;
    
    function getError(error) {
        if (window.location.href.indexOf("auctionProduct") > -1) {
            return $('<div class="unhappyMessageBar"><span id="' + error.id + '" class="unhappyMessage warningMsg"><p class="warningMsgText">' + error.message + '</span></p></div>');
        } else {
            return $('<span id="' + error.id + '" class="unhappyMessage">' + error.message + '</span>');
        }

    }
    function handleSubmit() {
        var errors = validateFields(fields);
      if (errors) {
        if (isFunction(config.unHappy)) config.unHappy();
        return false;
      } else if (config.testMode) {
        if (window.console) console.warn('would have submitted');
        return false;
      }
      else if(config.happy){
        config.happy();
        return true;
      }
    }
    function isFunction (obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    }
    function processField(opts, selector) {
      var field = $(selector),
        error = {
          message: opts.message,
          id: selector.slice(1) + '_unhappy'
        },
        errorEl = $(error.id).length > 0 ? $(error.id) : getError(error);
      fields.push(field);
      field.testValid = function (submit) {
        var val,
          el = $(this),
          gotFunc,
          error = false,
          temp, 
          //required = (!!el.get(0).attributes.getNamedItem('required') || opts.required) && isVisible(el.get(0)),
          //required = !!el.get(0).attributes.getNamedItem('required') || opts.required,
          password = (field.attr('type') === 'password'),
          arg = isFunction(opts.arg) ? opts.arg() : opts.arg;
        var required = false;
        if(isVisible(el.get(0)))
        {
            required = !!el.get(0).attributes.getNamedItem('required') || opts.required;
        }
        else
        {
            required = false;
        }
        // clean it or trim it
        if (isFunction(opts.clean)) {
          val = opts.clean(el.val());
        } else if (!opts.trim && !password) {
          val = trim(el);
        } else {
          val = el.val();
        }
        
        if(required && el.attr('type') == 'checkbox' && !el[0].checked) val ='';

        // write it back to the field
        el.val(val);
        
        // get the value
        gotFunc = ((val.length > 0 || required === 'sometimes') && isFunction(opts.test));
        
        // check if we've got an error on our hands
        if (submit === true && required === true && val.length === 0) {
          error = true;
        } else if (gotFunc) {
          error = !opts.test(val, arg);
        }
        
        if (error) {
            el.addClass('unhappy');
            if (el.attr("data-happy-specific-element") != null) {
                $(el.attr("data-happy-specific-element")).append(errorEl);
            }
            else if (el.attr("data-happy-error-before") != null) el.before(errorEl);
            else el.after(errorEl);
          return false;
        } else {
          temp = errorEl.get(0);
          // this is for zepto
          if (temp.parentNode) {
            temp.parentNode.removeChild(temp);
          }
          el.removeClass('unhappy');
          return true;
        }
      };
      field.bind(config.when || 'blur', field.testValid);
    }

    if (config.fields)
    for (item in config.fields) {
      processField(config.fields[item], item);
    }

    if (config.fields2) 
        for (var i = 0; i < config.fields2.length; i++) {
            processField(config.fields2[i].options, config.fields2[i].field);
        }
    
    if (config.submitButton) {
      $(config.submitButton).click(handleSubmit);
      // the trigger is not restricted to the button or the form
      if(config.triggerNotRestricted)
        this.bind('submit', handleSubmit);
    } else {
      this.bind('submit', handleSubmit);
    }

      if (this.length > 0) {
          if (this.data("happyValidFunc") == null)
              this.data("happyValidFunc", []);

          this.data("happyValidFunc").push(function() {
              return validateFields(fields);
          });
      }
      return this;
  };
})(window.jQuery || window.Zepto);